/**
 * Provides utilities for validating email addresses.
 *
 * @module EmailValidator
 * @see {@link https://emailregex.com/}
 */
/**
 * The default regex pattern used to validate email addresses.
 * This pattern conforms to the general email format.
 *
 * @constant
 * @type {RegExp}
 */
export const REGEX_EMAIL_VALIDATOR_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/**
 * The error message used when an expected regex pattern is not set.
 *
 * @constant
 * @type {string}
 */
export const REGEX_EMAIL_VALIDATOR_ERROR = 'Regular expression for email validations not set';
export class EmailValidator {
    constructor(regex = REGEX_EMAIL_VALIDATOR_PATTERN) {
        this.regex = regex;
        if (!regex) {
            throw new Error(REGEX_EMAIL_VALIDATOR_ERROR);
        }
    }
    validate(email) {
        return this.regex.test(email);
    }
}
//# sourceMappingURL=EmailValidator.js.map